<template>
  <v-container -max-width-limited>
    <v-skeleton-loader
        v-if="loading"
        type="image"
    ></v-skeleton-loader>
    <v-card v-if="message" color="red">
      <v-container grid-list-xl>
        {{message}}
      </v-container>
    </v-card>
    <v-card :color="'#eee'" class="mt-5 mb-5" v-for="(order, key) in orderList" :key="key">
      <v-container>
        <div class="col-md-12">
          <strong>{{ $t('Order') }} #{{ order.number }}
            <small v-if="order.orderDate">({{ formatDate(order.orderDate) }})</small>
          </strong>
          <span v-if="order.state"> | {{ $t('order.status.' + order.state) }}</span>
          <span v-if="order.shopOrderSystem"> | {{ $t('channel.code.' + order.shopOrderSystem) }}</span>
        </div>
        <div class="col-md-12">
          <v-btn
              @click="showDetails(order.number)"
          >
            {{ $t('Show Details') }}
          </v-btn>
        </div>
      </v-container>
    </v-card>

  </v-container>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router/composables";

import {OrderService} from "@/services/OrderService";
import {formatDate} from "@/services/globalFunctions";
import {ListedOrderResponseType} from "@/types/ListedOrderResponseType";

const router = useRouter()
const route = useRoute()

const orderList = ref<ListedOrderResponseType>({})
const loading = ref<boolean>(false)
const message = ref<string>('')

onMounted(() => {
  const email:string = route.query.email as string
  const channel:string = route.query.channel as string
  loading.value = true
  OrderService.getOrderByEmail(email, channel)
      .then(value => {
        loading.value = false
        orderList.value = value.orders
        console.log(orderList.value)
      })
      .catch(reason => {
        loading.value = false
        if (reason['errors'] !== undefined) {
          router.push({
            name: 'search',
            query: {message: reason.errors}
          })
        } else {
          console.log(reason)
          message.value = reason
        }
      });
})

const showDetails = (number:string) => {
  router.push({
    name: 'order_detail',
    params: {id: number}
  })
}
</script>